var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PCNavbar',{attrs:{"selectIndex":"1"}}),_c('CarouselHome'),_c('Contact'),_c('TodoShow'),_c('CoreCompetence'),_c('AboutUs'),_c('CallMe')],1)}
var staticRenderFns = []

export { render, staticRenderFns }